export const YB_POPUP_BUILDER = 'yb_popup_builder';
